<div class="d-flex justify-content-around">
  <div style="flex: 1;" *ngIf="userType !== 'user'">
    <p class="upper-text" translate>vehicles.vehicle.originalPhoto</p>
    <div class="img-edit-container" *ngIf="originalEdit == undefined">
      <div class="preview-image upload-file" style="background-size: 40%;"
        [style.background-image]="'url(assets/img/no-image.png)'"></div>
      <input type="file" name="image" accept="image/x-png,image/jpeg"
        (change)="getFile($event, 'original', 'add')" ngModel id="file-original"
        style="display: none;" />
    </div>
    <div class="img-edit-container" *ngIf="originalEdit != undefined">
      <div class="preview-image" style="cursor: pointer;" [style.background-image]="'url(' + originalEditPath + ')'">
      </div>
      <input type="file" name="image" accept="image/x-png,image/jpeg"
        (change)="getFile($event, 'original', 'patch')" ngModel id="file-originaladd"
        style="display: none;" />
    </div>
  </div>
  <div style="flex: 1;">
    <p class="upper-text" translate>vehicles.vehicle.mainPhoto</p>
    <div class="img-edit-container" *ngIf="mainImage === undefined && userType === 'root'">
      <div class="preview-image upload-file" (click)="fileSelect('main')" [style.background-image]="(mainUpload != null) ? 
                        'url(' + mainUpload + ')' : 'url(assets/img/upload-btn.svg)'"
        [style.background-size]="(mainUpload != null) ? '100%' : '40%'"></div>
      <input type="file" name="image" accept="image/x-png,image/jpeg" (change)="getFile($event, 'main', 'add')" ngModel
        id="file-main" style="display: none;" />
    </div>
    <div class="img-edit-container" *ngIf="mainImage != undefined">
      <div *ngIf="userType !== 'client'" class="preview-image" style="cursor: pointer;" [style.background-image]="'url(' + mainEditPath + ')'"
        (click)="fileSelect('mainadd')"></div>
      <div *ngIf="userType === 'client'" class="preview-image" style="cursor: pointer;" [style.background-image]="'url(' + mainEditPath + ')'"></div>  
      <input *ngIf="(userType === 'user' || userType === 'root' || userType === 'customer')" type="file" name="image" accept="image/x-png,image/jpeg" (change)="getFile($event, 'main', 'patch')"
        ngModel id="file-mainadd" style="display: none;" />
      <p *ngIf="userType === 'user'" class="small-text" translate>vehicles.vehicle.selectMain</p>
    </div>

    <p *ngIf="mainImage  !== undefined && userType === 'user'" class="small-text padding-top" translate>vehicles.vehicle.selectType</p>
    <select *ngIf="mainImage  !== undefined && userType === 'user'" class="custom-select" id="typeSelect" name="topic" required [(ngModel)]="newImage.type">
      <option value="0" disabled translate>vehicles.vehicle.selectType</option>
      <option value="exterior">exterior</option>
      <option value="interior">interior</option>
      <option value="details">details</option>
    </select>
    <div>
      <!-- <button class="upload-file-button" *ngIf="editImageId == ''" (click)="createImageAndFile()"
        translate>vehicles.vehicle.uploadFile</button> -->

      <button class="col-3 upload-file-button" *ngIf="editImageId && mainImage && userType === 'user'" [disabled]="isUploading"
        (click)="patchImageFile(imageForUpload, 'main')">
        <i *ngIf="isUploading" class="fa fa-spinner fa-spin"></i>
        <span *ngIf="!isUploading">{{ 'vehicles.vehicle.updateFile' | translate }}</span>
      </button>

      <button class="upload-file-button" *ngIf="userType === 'root' || userType === 'customer'" [disabled]="isUploading"
        (click)="uploadMainImage(imageForUpload)">
        <i *ngIf="isUploading" class="fa fa-spinner fa-spin"></i>
        <span *ngIf="!isUploading">{{ mainImage ? ('vehicles.vehicle.updateFile' | translate) : 'Upload' }}</span>
      </button>

      <!-- <button class="upload-file-button" *ngIf="editImageId != '' && mainImage == undefined"
        (click)="addImageFile(imageForUpload, 'main')" translate>vehicles.vehicle.updateNewFile</button> -->
    </div>
  </div>
</div>